module.exports = "/next-static/_next/static/images/hero_image_small-f9835e70556342d8a06f26d3f80fabb3.png";